import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('maintenancePage');

    return {
        DRONES_BREAKDOWN: ({ active, grounded }: { active: number; grounded: number }) =>
            t('dronesBreakdown', { active, grounded }),
        TITLE: t('title'),
        TOTAL_DRONES: t('totalDrones')
    };
};

export default useTranslation;
